export { LectureEntity } from './lecture-entity';
export { LectureEntityList } from './lecture-entity-list';

export type { Entity as LectureEntityType } from './lecture-entity';
